var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIconSlim28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0H0V28H28V0ZM27 1H1V27H27V1Z",
    fill: "#BF4818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.5H13V13H6.5V15H13V21.5H15V15H21.5V13H15V6.5Z",
    fill: "#BF4818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconSlim28);
export default __webpack_public_path__ + "static/media/PlusIconSlim28.1d5af7efc8ca5fdcab4fd4e395ed43d0.svg";
export { ForwardRef as ReactComponent };